function helm(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Dome -->
    <path d="M6,20 Q6,6 16,4 Q26,6 26,20 Z" fill="#CD7F32" stroke="rgba(0,0,0,0.25)" stroke-width="1"/>
    <!-- Face opening -->
    <path d="M10,18 Q16,22 22,18 L22,24 Q16,28 10,24 Z" fill="rgba(0,0,0,0.3)"/>
    <!-- Nose guard -->
    <line x1="16" y1="14" x2="16" y2="24" stroke="#CD7F32" stroke-width="2"/>
    <!-- Rim -->
    <path d="M6,20 Q16,24 26,20" fill="none" stroke="rgba(0,0,0,0.2)" stroke-width="1.5"/>
    <!-- Highlight -->
    <path d="M12,8 Q14,6 16,8" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="1.5"/>
  </svg>`;
}

function platemail(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Body -->
    <path d="M8,8 L6,28 L26,28 L24,8 Z" fill="#777" stroke="rgba(0,0,0,0.25)" stroke-width="1"/>
    <!-- Shoulders -->
    <path d="M8,8 Q4,6 2,10 L6,12" fill="#777" stroke="rgba(0,0,0,0.2)" stroke-width="0.8"/>
    <path d="M24,8 Q28,6 30,10 L26,12" fill="#777" stroke="rgba(0,0,0,0.2)" stroke-width="0.8"/>
    <!-- Neck -->
    <path d="M12,6 Q16,4 20,6" fill="none" stroke="#777" stroke-width="2"/>
    <!-- Center line -->
    <line x1="16" y1="8" x2="16" y2="26" stroke="rgba(0,0,0,0.15)" stroke-width="1"/>
    <!-- Highlight -->
    <path d="M10,12 L12,24" stroke="rgba(255,255,255,0.2)" stroke-width="1.5"/>
  </svg>`;
}

function wizardHat(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Brim -->
    <ellipse cx="16" cy="26" rx="14" ry="4" fill="#333" stroke="rgba(0,0,0,0.25)" stroke-width="1"/>
    <!-- Cone -->
    <path d="M8,26 L16,4 L24,26 Z" fill="#333" stroke="rgba(0,0,0,0.2)" stroke-width="1"/>
    <!-- Tip curl -->
    <path d="M16,4 Q20,2 18,6" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round"/>
    <!-- Band -->
    <path d="M9,24 Q16,20 23,24" fill="none" stroke="#FFD700" stroke-width="2"/>
    <!-- Star -->
    <polygon points="16,14 17,16 19,16 17.5,17.5 18,20 16,18.5 14,20 14.5,17.5 13,16 15,16" fill="#FFD700" opacity="0.8"/>
  </svg>`;
}

function robe(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Robe body -->
    <path d="M10,6 L6,28 L26,28 L22,6 Z" fill="#4a2080" stroke="rgba(0,0,0,0.2)" stroke-width="1"/>
    <!-- Collar -->
    <path d="M10,6 Q16,4 22,6 Q18,10 16,10 Q14,10 10,6 Z" fill="#5a30a0" stroke="rgba(0,0,0,0.15)" stroke-width="0.8"/>
    <!-- Sleeves -->
    <path d="M10,10 L4,18 L8,18" fill="#4a2080" stroke="rgba(0,0,0,0.15)" stroke-width="0.8"/>
    <path d="M22,10 L28,18 L24,18" fill="#4a2080" stroke="rgba(0,0,0,0.15)" stroke-width="0.8"/>
    <!-- Trim -->
    <path d="M8,26 Q16,24 24,26" fill="none" stroke="#FFD700" stroke-width="1"/>
    <!-- Center seam -->
    <line x1="16" y1="10" x2="16" y2="28" stroke="rgba(0,0,0,0.1)" stroke-width="0.8"/>
  </svg>`;
}

function tunic(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <!-- Body -->
    <path d="M10,8 L8,24 L24,24 L22,8 Z" fill="#228B22" stroke="rgba(0,0,0,0.2)" stroke-width="1"/>
    <!-- Collar -->
    <path d="M12,8 Q16,6 20,8 Q18,10 16,10 Q14,10 12,8 Z" fill="#1a7a1a" stroke="rgba(0,0,0,0.15)" stroke-width="0.8"/>
    <!-- Sleeves -->
    <path d="M10,10 L6,16 L9,16" fill="#228B22" stroke="rgba(0,0,0,0.15)" stroke-width="0.8"/>
    <path d="M22,10 L26,16 L23,16" fill="#228B22" stroke="rgba(0,0,0,0.15)" stroke-width="0.8"/>
    <!-- Belt -->
    <rect x="8" y="18" width="16" height="2" fill="#8B4513" stroke="rgba(0,0,0,0.15)" stroke-width="0.5"/>
    <circle cx="16" cy="19" r="1.5" fill="#C0C0C0"/>
    <!-- Bottom -->
    <path d="M8,24 L8,28 L24,28 L24,24" fill="#228B22" stroke="rgba(0,0,0,0.15)" stroke-width="0.8"/>
  </svg>`;
}

/**
 * Mallow's Rare Wick: a small amber flame floating free, with a soft halo and
 * a faint ring where a head would be. Coil-style 40x40 with `ci_mrw_*`
 * gradient ids, so several inline icons on one page never collide.
 */
function mallowsRareWick(size: number = 32): string {
  return `<svg width="${size}" height="${size}" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="ci_mrw_glow">
        <stop offset="0" stop-color="#ffd27a" stop-opacity="0.8"/>
        <stop offset="0.55" stop-color="#f2ae4f" stop-opacity="0.3"/>
        <stop offset="1" stop-color="#f2ae4f" stop-opacity="0"/>
      </radialGradient>
      <linearGradient id="ci_mrw_flame" x1="0%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stop-color="#e8873a"/>
        <stop offset="100%" stop-color="#f7c46a"/>
      </linearGradient>
    </defs>
    <!-- Halo -->
    <circle cx="20" cy="17" r="15" fill="url(#ci_mrw_glow)"/>
    <!-- A faint ring where the head would be -->
    <ellipse cx="20" cy="33.5" rx="10" ry="2.6" fill="none" stroke="#f2ae4f" stroke-width="1" opacity="0.45"/>
    <!-- Flame, leaning a little, with a pale core -->
    <path d="M19,4 C20.6,8 26,11.4 26,17.6 C26,22.4 23.2,25.4 20,25.4 C16.8,25.4 14,22.4 14,17.6 C14,13.2 17.6,10.4 19,4 Z" fill="url(#ci_mrw_flame)" stroke="#a8652a" stroke-width="0.9"/>
    <path d="M19.6,11.4 C20.4,13.8 22.6,15.8 22.6,18.8 C22.6,21.4 21.4,23.2 20,23.2 C18.6,23.2 17.4,21.4 17.4,18.8 C17.4,16.2 19,14.4 19.6,11.4 Z" fill="#fff4d6"/>
    <!-- Two drifting sparks -->
    <circle cx="27.5" cy="8" r="1.1" fill="#ffd27a"/>
    <circle cx="12" cy="11" r="0.8" fill="#ffd27a" opacity="0.8"/>
  </svg>`;
}

export const ARMOR_ICONS: Record<string, (size?: number) => string> = {
  bronze_helm: helm,
  iron_platemail: platemail,
  apprentice_hat: wizardHat,
  mallows_rare_wick: mallowsRareWick,
  mage_robe: robe,
  archer_tunic: tunic,
};
